var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vSelect", {
    staticClass: "h-full-width",
    class: _vm.missingClass,
    attrs: {
      name: _vm.field,
      options: _vm.options,
      "options-value": _vm.optionsValue,
      "options-label": _vm.optionsLabel,
      disabled: _vm.disabled,
      multiple: _vm.multiple,
      search: _vm.search,
      "show-count": _vm.showCount,
      placeholder: _vm.placeholder,
      "clear-button": _vm.clearButton
    },
    model: {
      value: _vm.model,
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }